import { useMainHeaderStore } from '@/components/main-header/store'

const PAGE_TO_ACTIVE_TAB: Record<string, string> = {
  'manage-my-booking': 'MMB',
  'self-service-portal': 'MMB',
  'check-in': 'CKI'
}

export const setMainHeaderActiveTabByPage = (page: string) => {
  const mainHeaderStore = useMainHeaderStore()
  mainHeaderStore.activeTab = PAGE_TO_ACTIVE_TAB[page] || 'FLT'
}
